var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-stars"},[_vm._l((this.score),function(x){return _c('span',{staticClass:"glyphicon glyphicon-star"})}),_vm._v(" "),_vm._l(((this.totalScore - this.score)),function(y){return _c('span',{staticClass:"glyphicon glyphicon-star-empty"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }